import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TemplateSelectionComponent } from './template-selection';

@NgModule({
  declarations: [
    TemplateSelectionComponent
  ],
  exports: [
    TemplateSelectionComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ProductModule { }
